import { ACTION } from './reducer';

const actions = {
  updateData({ reducerWizardDispatch, fieldName, value }) {
    reducerWizardDispatch({
      type: ACTION.UPDATE_DATA,
      payload: {
        data: {
          [fieldName]: value,
        },
      },
    });
  },

  updateIsFetchingData({ reducerWizardDispatch, isFetchingData }) {
    reducerWizardDispatch({
      type: ACTION.UPDATE_IS_FETCHING_DATA,
      payload: {
        isFetchingData,
      },
    });
  },
};

export default actions;
